"use client";
import { Link } from "@areahub/ui";
import { Box, Flex, Text } from "@chakra-ui/react";
import { LogoGallery as LogoGalleryProps } from "lib/gcms";
import { SectionTemplate } from "../section-template";
import { logos } from "./as-featured-on";

const LogoGallery = ({
  backgroundColor,
  textColor,
  shouldLink,
  children,
  from,
}: LogoGalleryProps & { from?: string }) => {
  const bgColor =
    backgroundColor !== "white"
      ? backgroundColor?.replace(/_/g, ".")
      : backgroundColor;
  return (
    <>
      <SectionTemplate
        {...{
          bg: bgColor,
          color: textColor,
        }}
        borderRadius={"0"}
        py={"15px"}
      >
        {children && (
          <Box
            textAlign="center"
            fontWeight="extrabold"
            letterSpacing="tight"
            sx={{ fontSize: "4xl" }}
          >
            {children}
          </Box>
        )}
        <Text
          fontSize={{
            base: 20,
            lg: 24,
          }}
          textAlign={"center"}
          fontWeight={"bold"}
        >
          Featured In:
        </Text>
        <Flex
          alignItems={from !== "custom" ? "center" : ""}
          justifyItems={from !== "custom" ? "center" : ""}
          justifySelf={from !== "custom" ? "center" : ""}
          m="auto"
          justifyContent={from !== "custom" ? "" : "space-evenly"}
          wrap={{
            base: "wrap",
            md: from !== "custom" ? "wrap" : "nowrap",
          }}
          maxW={from !== "custom" ? "3xl" : ""}
        >
          {logos.map(({ href, icon, color, desc, name }: any, idx: number) => {
            const stylingProps = {
              flexBasis: {
                base: from !== "custom" ? "45%" : "320%",
                md: 200,
              },
              mx: "auto",
              color,
              maxW: from !== "custom" ? "" : "220px",
              h: from !== "custom" ? "" : "110px",
              py: name === "AP" ? "15px" : "",
            };

            return shouldLink && href ? (
              <Link href={href} key={idx}>
                <Box as={icon} title={`${desc}`} {...stylingProps} />
              </Link>
            ) : (
              <Box key={idx} as={icon} {...stylingProps} />
            );
          })}
        </Flex>
      </SectionTemplate>
    </>
  );
};
export default LogoGallery;
